<template>
  <v-flex xs12>
    <div v-if="show" class="text-xs-left">
      <v-flex xs12>
        <v-card>
          <v-card-text v-if="hasNoContext">
            <h4>Send invites for {{natOrgObj.name}}</h4>
            <p>
              Total Licenses: {{totalLicenses}}
              <br>
              Unused Invites Available to Send: {{availableLicenses}}
              <br>
              <br>
            </p>
          </v-card-text>
          <v-card-text v-else>
            <h4>Choose National Organization to send invites for:</h4>
            <template v-for="(item, key) in natOrgs">
              <router-link :key="key" :to="{name:'Invite New Org Users', params: {noid:key}}">
                {{item.name}}
                <br>
              </router-link>
            </template>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card v-if="hasNoContext">
          <v-form v-if="availableLicenses" ref="form" v-model="valid" lazy-validation>
            <v-card-title>
              <span class="headline">Send up to {{availableLicenses}} Invites</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-textarea
                      v-model="emails"
                      label="Email Addresses"
                      :rules="isRequired"
                      required
                      hint="Paste a list of email addresses here, seperated by commas, spaces or new lines."
                    ></v-textarea>
                  </v-flex>

                  <v-flex xs12>
                    <v-select
                      v-model="selectedComps"
                      :items="comps"
                      attach
                      chips
                      label="Competitions"
                      multiple
                      hint="Select the competitions these users will be able to participate in"
                      persistent-hint
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="submit">Send</v-btn>
            </v-card-actions>

            <v-layout row justify-center>
              <v-dialog v-model="dialog" scrollable persistent max-width="600px">
                <v-card>
                  <v-card-title>
                    <span class="headline">Sent {{emailList.length}} Invites</span>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text style="height: 300px;">
                    <v-chip v-for="(item, index) in emailList" :key="index">{{item}}</v-chip>
                    <p v-if="selectedComps.length">And added them to {{selectedComps.length}} competitions</p>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="clear">Okay</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-layout>
          </v-form>
          <v-card-text v-else>
            <p>No invites available, request licenses with the Admin.</p>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>

    <v-card v-else>Admins Only</v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";
/*global firebase*/
export default {
  name: "InviteUsers",
  data: () => ({
    dialog: false,
    hasNoContext: false,
    noid: "",
    valid: true,
    selectedComps: [],
    emails: null,
    emailList: [],
    isRequired: [v => !!v || "Required with real email addresses"]
  }),
  watch: {
    // call again the method if the route changes
    $route: "init"
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(["isAdmin", "isNorgAdmin", "natOrgs"]),
    show() {
      return this.isAdmin || this.isNorgAdmin
    },
    natOrgObj() {
      return this.natOrgs[this.noid];
    },
    totalLicenses() {
      let noLicenses = this.$store.state.noLicenses[this.noid];
      if (noLicenses) {
        noLicenses = Object.values(noLicenses);
        return noLicenses.length;
      }
      return 0;
    },
    availableLicenses() {
      let noLicenses = this.$store.getters.licensesByNo(this.noid);
      if (noLicenses) {
        noLicenses = Object.values(noLicenses);
        return noLicenses.filter(lic => !lic.sent).length;
      }
      return 0;
    },
    comps() {
      let nOcompetitions = this.$store.getters.competitionByNo(this.noid);
      if (nOcompetitions) {
        let currCompVals = Object.values(nOcompetitions);
        let actualComps = currCompVals.map(k => {
          return { key: k, val: this.$store.getters.competitions[k] };
        });
        //endDate: new Date(this.endDate + "T12:00:00").getTime(),
        let today = new Date().getTime();
        let validComps = actualComps.filter(c => c.val.endDate > today);
        return validComps.map(c => {
          return { text: c.val.name, value: c.key };
        });
      }
      return false;
    }
  },
  methods: {
    init() {
      if (this.$route.params.noid) {
        this.noid = this.$route.params.noid;
        this.$store.dispatch("initNatOrg", this.noid);
        this.hasNoContext = true;
      } else {
        this.hasNoContext = false;
        this.$store.dispatch("initNatOrgs");
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.emailList = this.emails
          .replace(/\n/g, ",")
          .split(/[ ,]+/)
          .filter(function(v) {
            return /.+@.+/.test(v);
          });
        if (this.emailList.length) {
          let noLicenses = this.$store.state.noLicenses[this.noid];
          let updates = {};
          let i = 0;
          for (const key in noLicenses) {
            if (!noLicenses[key].sent) {
              let obj = noLicenses[key];
              obj.sent = true;
              obj.email = this.emailList[i].toLowerCase();
              obj.competitions = this.selectedComps
              updates["licenseinvites/" + this.noid + "/" + key] = obj;
              i++;
              if (i == this.emailList.length) {
                break; // out of loop, got enough keys...
              }
            }
          }
          this.emailList = this.emailList.slice(0, i); // crop to the amount sent...
          firebase
            .database()
            .ref()
            .update(updates);
          this.dialog = true;
        } else {
          this.emails = "";
          this.valid = false;
        }
      }
    },
    clear() {
      this.dialog = false;
      this.emailList = [];
      this.emails = null;
      this.$refs.form.reset();
    }
  }
};
</script>
